import "./App.css";
import About from "./components/about/about.component";
import Main from "./components/main/main.component";
import NavBar from "./components/nav-bar/nav-bar.component";
import NavButton from "./components/nav-button/nav-btn.component.js";
import Portfolio from "./components/portfolio/portfolio";


function App() {
 
  return (
    <div className="App">
    
        <div>
          <NavButton />
          <Main />
          <NavBar />
          <About />
          <Portfolio />
        </div>
      )
    </div>
  );
}

export default App;
